import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { Link } from 'react-router';

import AnonListenerCtaIcon from '../../../static/icons/anonymous_listening_signup_cta.svg';
import Icon from '../../components/Icon/Icon';
import ButtonT3 from '../../components/lib/ButtonT3/ButtonT3';
import { ButtonT3Size, ButtonT3Theme } from '../../components/lib/ButtonT3/constants';
import { messages as AuthMessages } from '../../constants/Anon';
import { message } from '../../constants/Welcome';
import * as RouteUtils from '../../lib/RouteUtils';
import { getIsSessionHistoryOpen } from '../../lib/UIStateUtils';
import { createBEM } from '../../lib/utils/css';

import './AnonWelcome.scss';

export class AnonWelcome extends React.Component {
  static propTypes = {
    isActive: PropTypes.bool.isRequired,
  };

  render() {
    const classes = createBEM('AnonWelcome', {
      active: this.props.isActive,
    });

    return (
      <div className={classes}>
        <div className='AnonWelcome__title'>
          <FormattedMessage {...message.anonWelcomeTitle} />
        </div>
        <div className='AnonWelcome__cta'>
          <Icon className='icon-anonWelcome' glyph={AnonListenerCtaIcon} />
        </div>
        <div className='AnonWelcome__body'>
          <FormattedMessage {...message.anonWelcomeBody} />
          <ButtonT3
            size={ButtonT3Size.DEFAULT}
            theme={ButtonT3Theme.WHITE}
            isFull={true}
            isBlock={true}
            href={RouteUtils.getRegisterPath()}
          >
            <FormattedMessage {...AuthMessages.signUp} />
          </ButtonT3>
        </div>
        <div className='AnonWelcome__subtext'>
          <FormattedMessage
            {...message.anonWelcomeSubText}
            values={{
              logIn: (
                <Link className='AnonWelcome__subtext__link' to={RouteUtils.getLoginPath()}>
                  <FormattedMessage {...AuthMessages.login} />
                </Link>
              ),
            }}
          />
        </div>
      </div>
    );
  }
}

export function mapStateToProps(state) {
  const path = RouteUtils.getCurrentPathnameFromState(state) || '';
  const isActive =
    RouteUtils.isPathInNowPlayingPath(path) &&
    !getIsSessionHistoryOpen(state) &&
    !RouteUtils.isStationDetailsPath(path);
  return {
    isActive,
  };
}

export default connect(mapStateToProps, {})(AnonWelcome);
